import { UserEntity } from "@lifeat/shared/data-models/user/UserEntity";
import { PomodoroWidgetSettingsEntity } from "@lifeat/shared/data-models/widget/Pomodoro/PomodoroWidgetSettingsEntity";
import { USERS_NODE } from "@lifeat/shared/rtdb-nodes/RtdbNodes";
import { PomodoroTimerType } from "@lifeat/shared/widget/PomodoroTimerTypes";
import { db, firebase, functions } from "@firebase-local/firebase";
import { POMODORO_WIDGET_FUNCTIONS } from "@firebase-local/functions/ServerlessEndpoints";
import { logError } from "@service/ConsoleLoggerService";
import { PomodoroAnalyticsService } from "./PomodoroAnalyticsService";
import { PomodoroService } from "./PomodoroService";

export function PersonalPomodoroService(
    user: firebase.User,
    userData: UserEntity,
    analytics?: PomodoroAnalyticsService,
): PomodoroService {
    const fetchProAlarmSounds = async () => {
        try {
            const result = await functions.httpsCallable(POMODORO_WIDGET_FUNCTIONS.FetchProAlarmSounds)({});
            return result.data;
        } catch (error) {
            logError(error);
        }
    };

    const updateSelectedAlarmSrc = async (alarmId: string) => {
        try {
            const result = await functions.httpsCallable(POMODORO_WIDGET_FUNCTIONS.UpdateSelectedAlarmSrc)({
                alarmId: alarmId,
            });
            if (result.data !== undefined) {
                if (!result.data) {
                    alert("Invalid sound ID. Please try again. " + result.data);
                }
            }
        } catch (error) {
            logError(error);
        }
    };

    const fetchSettings = async (): Promise<PomodoroWidgetSettingsEntity | null> => {
        return userData.pomodoroWidgetSettings ?? null;
    };

    const updatePomodoroSettings = async (value: Partial<PomodoroWidgetSettingsEntity>) => {
        if (user && user.emailVerified) {
            const uid = user.uid;
            const pomodoroSettingsPath = `/${USERS_NODE.name}/${uid}/${USERS_NODE.children.POMODORO_WIDGET_SETTINGS.name}`;
            db.ref(pomodoroSettingsPath).update(value);
        }
    };

    const logTimerStartEvent = (timerType: PomodoroTimerType, fromClick: boolean) => {
        analytics?.log({
            eventType: "start",
            fromClick,
            timerType,
            timerMode: "personal",
        });
    };

    const logTimerEndEvent = (timerType: PomodoroTimerType) => {
        analytics?.log({
            eventType: "end",
            timerType,
            timerMode: "personal",
        });
    };

    return {
        fetchProAlarmSounds,
        updateSettings: updatePomodoroSettings,
        fetchSettings,
        updateSelectedAlarmSrc,
        logTimerStartEvent,
        logTimerEndEvent,
    };
}
